module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"see_more":"En voir plus"}}')
  delete Component.options._Ctor
}
